'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var vue = Symbol('The vue instance');

var EventDispatcher = function () {
  function EventDispatcher() {
    _classCallCheck(this, EventDispatcher);

    this[vue] = new _vue2.default();
  }

  _createClass(EventDispatcher, [{
    key: 'fire',
    value: function fire(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this[vue].$emit(event, data);
    }
  }, {
    key: 'listen',
    value: function listen(event, callback) {
      this[vue].$on(event, callback);
    }
  }]);

  return EventDispatcher;
}();

exports.default = EventDispatcher;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ctxs-vue-plugins/dist/classes/EventDispatcher.js
// module id = 0xCp
// module chunks = 0